import { render, staticRenderFns } from "./Avicourse.vue?vue&type=template&id=bbbf5b38&scoped=true&"
import script from "./Avicourse.vue?vue&type=script&lang=js&"
export * from "./Avicourse.vue?vue&type=script&lang=js&"
import style0 from "./Avicourse.vue?vue&type=style&index=0&id=bbbf5b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf5b38",
  null
  
)

export default component.exports